/* task: get data from API */
export const DESKTOP_BOTTOM = 'Desktop_Bottom';
export const DESKTOP_BOTTOM2 = 'Desktop_Bottom2';
export const MOBILE_SLOT2 = 'Mobile_Slot2';
export const MOBILE_SLOT3 = 'Mobile_Slot3';
export const MOBILE_SLOT4 = 'Mobile_Slot4';
export const DESKTOP_RIGHT1 = 'Desktop_Right1';
export const MOBILE_IN_NEWS1 = 'Mobile_In_News1';
export const DESKTOP_RIGHT3 = 'Desktop_Right3';

export const SLOTS_MAPPING = {
  [MOBILE_IN_NEWS1]: {
    code: 'js-adfox-mobile-in-news1',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-mobile-in-news1',
      params: {
        p1: 'cwzkq',
        p2: 'gfdy'
      }
    }
  },
  [DESKTOP_RIGHT1]: {
    code: 'js-adfox-desktop-right',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-desktop-right',
      reloadInterval: 60,
      params: {
        p1: 'crsny',
        p2: 'gfdy'
      }
    }
  },
  [MOBILE_SLOT2]: {
    code: 'js-adfox-mobile-slot2',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-mobile-slot2',
      reloadInterval: 60,
      params: {
        p1: 'crsnz',
        p2: 'gfdy'
      }
    }
  },
  [MOBILE_SLOT3]: {
    code: 'js-adfox-mobile-slot3',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-mobile-slot3',
      params: {
        p1: 'cwavd',
        p2: 'gfdy'
      }
    }
  },
  [MOBILE_SLOT4]: {
    code: 'js-adfox-mobile-slot4',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-mobile-slot4',
      params: {
        p1: 'cwzks',
        p2: 'gfdy'
      }
    }
  },
  [DESKTOP_BOTTOM]: {
    code: 'js-adfox-desktop-bottom1',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-desktop-bottom1',
      reloadInterval: 60,
      params: {
        p1: 'cwzkh',
        p2: 'gfdy'
      }
    }
  },
  [DESKTOP_BOTTOM2]: {
    code: 'js-adfox-desktop-bottom2',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-desktop-bottom2',
      reloadInterval: 60,
      params: {
        p1: 'cwzki',
        p2: 'gfdy'
      }
    }
  },
  [DESKTOP_RIGHT3]: {
    code: 'js-adfox-desktop-right2',
    adfoxParams: {
      ownerId: 252771,
      containerId: 'js-adfox-desktop-right2',
      params: {
        p1: 'cwzkf',
        p2: 'gfdy'
      }
    }
  }
};
